import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Faz scroll para o topo a cada mudança de rota.
 * Montado dentro do BrowserRouter.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;